import React from 'react'
import { useDrop } from 'react-dnd'

import Footer from './Footer'
import Layer from './Layer'
import Legend from './Legend'
import Modus from './Modus'
import SearchBar from './SearchBar'
import { COLORS, ITEM_TYPES } from '../Constants'
import { useStateValue } from './StateProvider'

const Main = () => {
  const [{ countryStats, darkmode, selected }, dispatch] = useStateValue()
  const [{ isOver, item }, drop] = useDrop({
      accept: ITEM_TYPES.OPTION,
      drop: () => {
          dispatch({
              type: 'UPDATE_SELECTED',
              item: countryStats[item.id],
          })
      },
      collect: monitor => ({
          isOver: monitor.isOver(),
          item: monitor.getItem()
      }),
  })

  const changeColorMode = (darkmode) => {
    dispatch({
      type: 'UPDATE_DARKMODE',
      item: darkmode,
    })
  }

  return (
    <div className='main' ref={drop} style={{
      borderColor: isOver && COLORS.selected_border_color,
    }}>
      <div className='main__top'>
        <div className='main__searchbar'>
          <SearchBar />
        </div>
        <div className='main__canvas' style={{
          gridTemplateColumns: `${selected === null ? '100%' : 'repeat(2, auto)'}`,
        }}>
          {selected !== null && <Legend />}
          <Layer />
        </div>
      </div>
      <div className='main__bottom'>
        <Modus />
        <Footer />
      </div>
    </div>
  )
}

export default Main